import Config from '../../../config/Config'
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { jwtSelector } from '../../auth/selectors'
import * as actions from '../actions'

export const getTargetingObservable = ([action, state]) => {
  const { type, fields } = action.payload
  const jwt = jwtSelector(state) || action.payload.jwt

  if (!jwt) {
    throw new Error('Non-existent JWT auth')
  }

  if (!type) {
    throw new Error('Type required')
  }

  let paramsList = []
  if (type) {
    paramsList.push(`type=${type}`)
  }
  if (fields) {
    paramsList.push(`fields=${fields.join(',')}`)
  }

  const settings = {
    method: 'GET',
    responseType: 'json',
    headers: {
      Authorization: jwt,
    },
    url: `${
      Config.SERVICE_BASE
    }/facebookad/v1/targeting/browse?${paramsList.join('&')}`,
  }

  return ajax(settings).pipe(
    map((payload) => {
      return {
        type: actions.GET_TARGETING_FULFILLED,
        payload: payload.response,
      }
    }),
    catchError((payload) => {
      return of({
        type: actions.GET_TARGETING_REJECTED,
        payload: payload.response,
      })
    }),
  )
}

export const getTargetingEpic = (action$, state$) => {
  return action$.pipe(
    ofType(actions.GET_TARGETING),
    withLatestFrom(state$),
    mergeMap(getTargetingObservable),
    catchError((payload) => {
      return of({
        type: actions.GET_TARGETING_REJECTED,
        payload,
      })
    }),
  )
}
